import { resourceHelper } from './helpers';
import app from '$$app';

async function onTaskResourceAssigned(event) {
  const { data, innerSettings } = event;
  let taskIds = [];

  if (innerSettings.projectId) {
    taskIds = resourceHelper(data.assignedResources, +innerSettings.projectId, innerSettings.resourcesToTasks);
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    projects: [event.innerSettings.projectId],
    tasks: taskIds,
  });
}

export default onTaskResourceAssigned;
